import './tags.scss'
import {useEffect, useState} from "react";
import {
    Tag
} from '@chakra-ui/react'

const Tags = ({securities, setTagSelected, selectedTag}) => {
    const handleClick = (security) => {
        if (selectedTag === security) {
            setTagSelected(null);
        } else {
            setTagSelected(security);
        }
    };

    return (
        <div className='tags-section'>
            {securities.map((security, index) => (
                <Tag
                    onClick={() => handleClick(security)}
                    className={`tag ${selectedTag === security ? 'active' : ''}`}
                    key={index}>{security}</Tag>
            ))}
        </div>
    );
}

export default Tags;